import { ARTICLE_FIELDS, DISCOVERY_FIELDS, PUBLISHED, IMAGE_META, DESCRIPTION_META, ASSOCIATED_DATASET, TAG_UUID, SEND_EMAILS, FORCE_SEND_EMAILS, TEMPLATE_UUID, SPECIAL } from 'constant/form-item-names'
import _ from 'lodash'

export default (values, isDiscovery = false) => {
  if (values.is_draft) {
    return values.is_draft
  }
  const valueToCheck = _.omit(values, [PUBLISHED, IMAGE_META, DESCRIPTION_META, 'uuid', 'is_draft', ASSOCIATED_DATASET, TAG_UUID, SEND_EMAILS, FORCE_SEND_EMAILS, TEMPLATE_UUID, SPECIAL])
  const FIELDS = isDiscovery ? DISCOVERY_FIELDS : ARTICLE_FIELDS
  const hasAllKeys = _.values(FIELDS).every((field) => _.keys(valueToCheck).includes(field))

  const hasAllValues = !_.values(valueToCheck).some(_.isEmpty)

  return !(hasAllKeys && hasAllValues)
}
